import React, { useContext } from "react";
import { Badge, Text, Link, InlineStack, Thumbnail, BlockStack, Box, Divider } from "@shopify/polaris";
import { PrivateContext } from "lib/context";
import constant from "lib/constant/constant";
import { statusHelper, baseHelper, imageHelper } from "lib/helpers";
import { useNavigate } from "react-router-dom";

const ReturnedLineItems = (props) => {
  const { data, lineItemArray } = props;
  const { cms } = useContext(PrivateContext);

  const navigate = useNavigate();

  const lineItems = lineItemArray
    .filter(
      (lineItem) =>
        lineItem.fulfillmentStatus === constant.FULFILLED &&
        lineItem.returnedQuantity &&
        lineItem.returnedQuantity !== constant.value.ZERO
    )
    .map((lineItem, idx) => {
      const {
        actualQuantity,
        image = "",
        isProductDeleted,
        moneyFormat: lineMoneyFormat,
        name,
        price,
        productId,
        quantity,
        sku,
        returnedQuantity,
        vendor,
        vendorId,
      } = lineItem || {};

      const lineItemKey = `lineItem${idx}`;
      const lineImage = imageHelper.resize({ url: image, type: constant.imageTypes.THUMBNAIL }) || constant.NOIMAGESNAP;

      const moneyFormat = lineMoneyFormat || constant.symbol.DOLLAR;
      const status =
        returnedQuantity < (actualQuantity || quantity)
          ? statusHelper.getBadgeStatus(constant.PARTIAL_RETURN)
          : statusHelper.getBadgeStatus(constant.RETURN);
      const badgeType = baseHelper.getBadgeType(constant.RETURN);
      const totalPrice = parseFloat(price) * parseInt(returnedQuantity, 10);

      const lineItemName = <div className="productName">{name}</div>;

      return (
        <div key={lineItemKey} className="fulfilled-Secn">
          <Box padding="400">
            <InlineStack wrap={false} align="space-between">
              <InlineStack wrap={false} gap="400">
                <Thumbnail size="large" source={lineImage} alt={name} />
                <BlockStack gap="400" inlineAlign="start">
                  {(isProductDeleted && (lineItemName || "")) || (
                    <Link onClick={() => navigate(`/products/edit/${productId}`)}>{lineItem.name || ""}</Link>
                  )}

                  <Text variant="bodySm" as="p">
                    <Text as="span" color={constant.SUBDUED}>
                      {vendor && vendorId && `${cms("label.vendor")}: ${vendor}`}
                    </Text>
                    <Text as="span" color={constant.SUBDUED}>{`${cms("label.skuList")} ${sku}`}</Text>
                  </Text>
                  <Badge status={badgeType} className="text-capitalize">
                    {status}
                  </Badge>
                </BlockStack>
              </InlineStack>
              <InlineStack wrap={false}>
                <Text as="span">
                  {`${cms("label.qty")}:`}
                  {returnedQuantity}
                </Text>
                <Text as="span">
                  {moneyFormat}
                  {(totalPrice && totalPrice.toFixed(2)) || constant.value.ZERO}
                </Text>
              </InlineStack>
            </InlineStack>
          </Box>
        </div>
      );
    });
  const renderTotalAmount = () => {
    const amount = [];
    const vendorsSum = [];
    let countItems = 0;
    const moneyFormat = data.moneyFormat || constant.symbol.DOLLAR;

    lineItemArray
      .filter(
        (lineItem) =>
          lineItem.fulfillmentStatus === constant.FULFILLED && lineItem.returnedQuantity !== constant.value.ZERO
      )
      .forEach(({ returnedQuantity = 1, price, vendor }) => {
        vendorsSum.push(vendor);
        amount.push(parseFloat(price) * parseInt(returnedQuantity, 10));
        countItems += 1;
      });

    const vendorSet = new Set(vendorsSum);
    const setSize = vendorSet.size;
    const addVendorTxt =
      setSize === constant.value.ONE ? `${setSize} ${cms("label.vendor")}` : `${setSize} ${cms("label.vendors")}`;

    const stringToNumber = amount.map((item) => parseFloat(item));
    const totalAmount = stringToNumber.reduce((cur, acc) => cur + acc, constant.value.ZERO);

    return (
      <>
        <Divider />
        <Box padding="400">
          <InlineStack blockAlign="center" align="space-between">
            <Text as="span" fontWeight="semibold">
              {cms("label.total")}
            </Text>
            <InlineStack blockAlign="center" gap="400">
              <Text variant="bodySm" as="p">
                (
                {countItems > 1
                  ? `${countItems}
                ${cms("label.items")} from ${addVendorTxt}`
                  : `${countItems}
                ${cms("label.item")} from ${addVendorTxt}`}
                )
              </Text>
              <Text as="span" fontWeight="semibold">{`${moneyFormat}${totalAmount.toFixed(2)}`}</Text>
            </InlineStack>
          </InlineStack>
        </Box>
      </>
    );
  };
  return [lineItems, renderTotalAmount()];
};

export default ReturnedLineItems;
